import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions(['$showSpinner', '$hideSpinner', '$resetSpinner'])
  }
}
